import BaseModelAPI from '../BaseModelAPI';

export default class Division extends BaseModelAPI {
	static entity = 'division';
	static entityName = 'division';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}